<script setup>
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - Project Test` : 'Project Test'
  },
})
</script>

<template>
  <Suspense>
    <nuxt-layout>
      <nuxt-page />
    </nuxt-layout>
  </Suspense>
</template>
